/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { Field } from "formik";
import { EditComponentProps } from "material-table";
import { makeStyles, Theme, createStyles } from "@material-ui/core";
import { PlainSelect, PlainSelectDef } from "../../../../../components";
import { FileCrawlingConfigDataRow } from "../../../../../types/config";
import { crawlingModeDefs } from "../helpers/file-crawling-config-helper";
import { OptionData } from "../../../../../types";
import { ConnectionsApi } from "../../../../../helpers";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pulldown: {
      width: "6rem",
    },
    configDialogOpenButton: {
      marginTop: "1rem",
      color: theme.palette.text.secondary,
    },
  })
);

interface Props extends EditComponentProps<FileCrawlingConfigDataRow> {
  autoFocus?: boolean;
  onError?: (error: any) => void;
}

/** 接続先設定編集コンポーネント */
export function CrawlingModeEditComponent(props: Props) {
  const classes = useStyles();

  const { value: fieldValue, autoFocus, onError, rowData } = props;

  // DOMにあるFieldタグの外でfieldValueを更新したいので、参照を保持する
  let setFieldValueRef: any = null;
  let fieldNameRef: any = null;

  // クロールモード 選択肢
  const [crawlingModeOptions, setCrawlingModeOptions] = React.useState<
    OptionData[]
  >([]);

  const calculatedValue =
    // Object.keys(fieldValue).length === 0 ? { name: "", value: "" } : fieldValue;
    crawlingModeOptions.length === 1 ? crawlingModeOptions[0] : fieldValue;

  // クロールモード 選択肢初期化
  const initCrawlingModeOptions = () => {
    const fetchData = async () => {
      try {
        // 接続先に接続先機器の登録があるか判定
        // ない場合は、クロールモードの選択肢に「全て」のみをセット
        let hasConnectionDevice = false;
        const connectionId: number | null =
          "value" in rowData.connection
            ? parseInt(rowData.connection.value, 10)
            : null;
        if (connectionId) {
          const res: any = await ConnectionsApi.retrieve(connectionId);
          const connection = res.data;
          hasConnectionDevice =
            connection !== undefined && connection.connection_device !== null;
        }
        const optionData = hasConnectionDevice
          ? crawlingModeDefs
          : [crawlingModeDefs[0]];
        if (!hasConnectionDevice) {
          props.onChange(crawlingModeDefs[0]); // for MaterialTable
          setFieldValueRef(fieldNameRef, crawlingModeDefs[0]); // for Formik
        }
        setCrawlingModeOptions(optionData);
      } catch (error: any) {
        if (onError) {
          onError(error);
        }
      }
    };
    fetchData();
  };

  // 接続先変更時
  React.useEffect(() => {
    // クロールモード 選択肢初期化
    initCrawlingModeOptions();
  }, [rowData.connection]);

  //--------------------
  // コンポーネント
  return (
    // eslint-disable-next-line react/destructuring-assignment
    <Field name={props.columnDef.field}>
      {(args: any) => {
        const { field, form } = args;
        const { name } = field;
        const { errors, touched, setFieldValue } = form;

        // Fieldタグの外でfieldValueを更新したいので、参照をセットする
        setFieldValueRef = setFieldValue;
        fieldNameRef = name;

        // onChange, onBlur, name and value は
        // name で引き当てて HtmlのReactコンポーネントに自動注入するが、
        // 上手くnameを設定すればいけるかもしれないが、
        // フォーカスアウト時にはtouchedにできていない。
        // それでも、適用ボタンを押下時にtouchedになるのでそれで良しとする。

        return (
          <>
            {/*
              クロール対象
            */}
            <PlainSelect
              {...props}
              {...field}
              id="id_crawling_mode"
              label="クロール対象"
              data={calculatedValue.value}
              defs={crawlingModeOptions}
              handleChange={(event: React.ChangeEvent<any>) => {
                const { value: eValue } = event.target;
                if (typeof eValue === "string") {
                  const selectedCrawlingMode = crawlingModeOptions.find(
                    (def: PlainSelectDef) => def.value === eValue
                  );
                  if (selectedCrawlingMode) {
                    const newCrawlingMode = {
                      name: selectedCrawlingMode.name,
                      value: eValue,
                    };
                    props.onChange(newCrawlingMode); // for MaterialTable
                    setFieldValue(name, newCrawlingMode); // for Formik
                  }
                }
              }}
              error={touched[name] && errors[name]}
              helperText={touched[name] && errors[name]}
              autoFocus={autoFocus}
              className={classes.pulldown}
            />
          </>
        );
      }}
    </Field>
  );
}
